// font weight
const fontWeightBold = {
  fontWeight: 700,
};
const fontWeightMedium = {
  fontWeight: 500,
};
const fontWeightRegular = {
  fontWeight: 400,
};

//---------------------------------------------

// Heading
const h1Options = {
  fontSize: 48,
  lineHeight: "57.6px",
};
const h2Options = {
  fontSize: 36,
  lineHeight: "43.2px",
};
const h3Options = {
  fontSize: 30,
  lineHeight: "36px",
};
const h4Options = {
  fontSize: 24,
  lineHeight: "28.8px",
};
const h5Options = {
  fontSize: 18,
  lineHeight: "21.6px",
};
const h6Options = {
  fontSize: 14,
  lineHeight: "16.8px",
};
const fontFamilyBody = {
  fontFamily: "Poppins",
};

//---------------------------------------------

// Body
const b1Options = {
  fontSize: 24,
  lineHeight: "28.8px",
};
const b2Options = {
  fontSize: 20,
  lineHeight: "24px",
};
const b3Options = {
  fontSize: 18,
  lineHeight: "21.6px",
};
const b4Options = {
  fontSize: 16,
  lineHeight: "19.2px",
};
const b5Options = {
  fontSize: 14,
  lineHeight: "19.6px",
};
const b6Options = {
  fontSize: 12,
  lineHeight: "16.8px",
};
const fontFamilyHeading = {
  fontFamily: "Verdana",
};

//---------------------------------------------

export default {
  // Heading
  "&.heading-h1-bold": {
    ...h1Options,
    ...fontWeightBold,
    ...fontFamilyHeading,
  },
  "&.heading-h2-bold": {
    ...h2Options,
    ...fontWeightBold,
    ...fontFamilyHeading,
  },
  "&.heading-h3-bold": {
    ...h3Options,
    ...fontWeightBold,
    ...fontFamilyHeading,
  },
  "&.heading-h4-bold": {
    ...h4Options,
    ...fontWeightBold,
    ...fontFamilyHeading,
  },
  "&.heading-h5-bold": {
    ...h5Options,
    ...fontWeightBold,
    ...fontFamilyHeading,
  },
  "&.heading-h6-bold": {
    ...h6Options,
    ...fontWeightBold,
    ...fontFamilyHeading,
  },

  //---------------------------------------------

  // Body b1
  "&.body-b1-bold": {
    ...b1Options,
    ...fontWeightBold,
    ...fontFamilyBody,
  },
  "&.body-b1-medium": {
    ...b1Options,
    ...fontWeightMedium,
    ...fontFamilyBody,
  },
  "&.body-b1-regular": {
    ...b1Options,
    ...fontWeightRegular,
    ...fontFamilyBody,
  },

  // Body b2
  "&.body-b2-bold": {
    ...b2Options,
    ...fontWeightBold,
    ...fontFamilyBody,
  },
  "&.body-b2-medium": {
    ...b2Options,
    ...fontWeightMedium,
    ...fontFamilyBody,
  },
  "&.body-b2-regular": {
    ...b2Options,
    ...fontWeightRegular,
    ...fontFamilyBody,
  },

  // Body b3
  "&.body-b3-bold": {
    ...b3Options,
    ...fontWeightBold,
    ...fontFamilyBody,
  },
  "&.body-b3-medium": {
    ...b3Options,
    ...fontWeightMedium,
    ...fontFamilyBody,
  },
  "&.body-b3-regular": {
    ...b3Options,
    ...fontWeightRegular,
    ...fontFamilyBody,
  },

  // Body b4
  "&.body-b4-bold": {
    ...b4Options,
    ...fontWeightBold,
    ...fontFamilyBody,
  },
  "&.body-b4-medium": {
    ...b4Options,
    ...fontWeightMedium,
    ...fontFamilyBody,
  },

  "&.body-b4-regular": {
    ...b4Options,
    ...fontWeightRegular,
    ...fontFamilyBody,
  },

  // Body b5
  "&.body-b5-bold": {
    ...b5Options,
    ...fontWeightBold,
    ...fontFamilyBody,
  },
  "&.body-b5-medium": {
    ...b5Options,
    ...fontWeightMedium,
    ...fontFamilyBody,
  },
  "&.body-b5-regular": {
    ...b5Options,
    ...fontWeightRegular,
    ...fontFamilyBody,
  },

  // Body b6
  "&.body-b6-bold": {
    ...b6Options,
    ...fontWeightBold,
    ...fontFamilyBody,
  },
  "&.body-b6-medium": {
    ...b6Options,
    ...fontWeightMedium,
    ...fontFamilyBody,
  },
  "&.body-b6-regular": {
    ...b6Options,
    ...fontWeightRegular,
    ...fontFamilyBody,
  },
};
